import Swup from "swup";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupHeadPlugin from "@swup/head-plugin";
import SwupJsPlugin from "@swup/js-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupGaPlugin from "@swup/ga-plugin";
import { AccordionController } from "./acc";
import { ScrollFade } from "./scrollmagic";
import { contactInit } from "./contact";
import { OnClickManager } from "./onclicks";
import { topInit } from "./top";
import { splashInit } from "./splash";

if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
}

const swup = new Swup({
    animateHistoryBrowsing: true,
    containers: [".swup-wrapper"],
    plugins: [
        new SwupBodyClassPlugin(),
        new SwupPreloadPlugin(),
        new SwupHeadPlugin(),
        new SwupJsPlugin({
            animations: [
                {
                    from: "(.*)", // matches any route
                    to: "(.*)", // matches any route
                    out: (done) => setTimeout(done, 450),
                    in: (done) => setTimeout(done, 500 + 150),
                },
            ],
        }),
        new SwupScrollPlugin({
            animateScroll: {
                betweenPages: false,
                samePageWithHash: true,
                samePage: true,
            },
            scrollAcceleration: 0.04,
        }),
        // new SwupGaPlugin({ gaMeasurementId: "G-Y8LC3PX7PD" }),
    ],
});

let unmounts = [],
    popstate = false;

const every = (visit) => {
    const accordion = new AccordionController();
    unmounts.push(accordion.unmount);

    const sf = new ScrollFade();
    unmounts.push(sf.destroy);

    unmounts.push(contactInit());

    OnClickManager.init();
    OnClickManager.initModalBackground();
    unmounts.push(() => {
        OnClickManager.unmount();
    });

    unmounts.push(topInit());
    unmounts.push(splashInit());
    // unmounts.push();
};

swup.hooks.on("animation:out:start", (visit) => {
    unmounts.forEach((un) => {
        un();
    });
    unmounts = [];
});

swup.hooks.on("page:view", (visit) => {
    every(visit);
});

swup.hooks.on("visit:end", (visit) => {});

swup.hooks.on("animation:in:start", (visit) => {
    if (popstate) {
        popstate = false;
    } else {
        if (visit.to.hash === "") {
            swup.scrollTo(0, false);
        } else {
            const anchor = document.querySelector(visit.to.hash);
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;

            const computedStyle = window.getComputedStyle(anchor);
            const scrollMarginTop =
                parseInt(computedStyle.scrollMarginTop, 10) || 0;

            const target =
                anchor.getBoundingClientRect().top +
                scrollTop -
                scrollMarginTop;

            swup.scrollTo(target, false);
        }
    }
});
swup.hooks.on("enable", every);

swup.hooks.on("history:popstate", () => {
    popstate = true;
});
